module.exports = __webpack_public_path__ + "e7da647.woff2";